export default [
  {
    path: '/activity-20260708-main',
    component: () => import('./Page.vue'),
    meta: {
      title: 'HiFun世界杯2026',
      activity_code: 'activity_20260708_worldcup',
      activity_id: 36,
    },
  },
  {
    path: '/activity-20260708-rule',
    component: () => import('./Rule.vue'),
    meta: {
      title: '活动规则',
      activity_code: 'activity_20260708_worldcup',
      activity_id: 36,
    },
  },
]
